import type { Ref, ComputedRef } from "vue";

export interface UseSearchEscapeOptions {
  searchTerm: Ref<string>;
  canOpen: () => boolean;
  clear?: () => void;
}

export interface UseSearchEscapeReturn {
  open: ComputedRef<boolean>;
  onEscape: (e: KeyboardEvent) => void;
  dismiss: () => void;
}

export function useAppSearchEscape(options: UseSearchEscapeOptions): UseSearchEscapeReturn {
  const dismissed = ref(false);
  watch(options.searchTerm, () => {
    dismissed.value = false;
  });

  const open = computed(() => options.canOpen() && !dismissed.value);

  function dismiss() {
    dismissed.value = true;
  }

  function onEscape(e: KeyboardEvent) {
    if (open.value) dismiss();
    else if (options.searchTerm.value && options.clear) options.clear();
    else return;
    e.preventDefault();
    e.stopPropagation();
  }

  return { open, onEscape, dismiss };
}
